/* src/app/app.component.scss */
html,
body {
  height: 99%;
}
::ng-deep .mat-mdc-option .mdc-list-item__primary-text {
  width: auto;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  overflow: hidden;
}
::ng-deep .e-reportviewer-txtitem {
  max-height: none !important;
}
/*# sourceMappingURL=app.component.css.map */
